export default "__VITE_ASSET__DK0jAW1q__"